import {tag} from '@/api-services'
import {errorHandler} from '@/utils/handler'
import {toast} from '@/utils/toast'
import {defineStore} from 'pinia'

export const useTagStore = defineStore('tagStore', {
  state: () => ({
    allTags: [],
    tagDetail: {},
    loading: false,
    error: null,
  }),
  getters: {
    tagsWithNameAndValue: (state) => state.allTags.map((tag) => ({name: tag, value: tag})),
  },
  actions: {
    async getAllTags() {
        this.loading = true
        try {
        const response = await tag.getAllTag()
        const data = response.data
        this.allTags = data
      } catch (error) {
        error.map((e) => {
          const errorMsg = errorHandler(e)
          this.error = errorMsg
          toast.error(errorMsg)
        })
      } finally {
        this.loading = false
      }
    },
  },
})
